import { setShowCreateInvoiceModal } from '../State/showCreateInvoiceModal';

export default () => async (dispatch) => {
  dispatch(setShowCreateInvoiceModal(false));
}